// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
  
// } from "react-bootstrap"; 

// export default function CBFL() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                               <div>
//                                   <h1>Creation of Backward and Forward Linkages from MOFPI</h1>

//                                   <h2>Objective of CBFL:</h2>
//                                   <p>Objective of the Scheme is to provide seamless and efficient back and forth integration for the processed food industry and to plugin gaps in the supply chain in terms of raw material availability and market connectivity. Under the scheme financial assistance is provide for setting up Primary processing centers / collection centers at the farm and modern retail stores at the front as well as connection via insulated / refrigerated transports.</p>

//                                   <h2>About the CBFL Scheme:</h2>
//                                   <p>The scheme applies to perishable horticulture and non-horticultural products such as fruit, vegetables, dairy products, meat, poultry, fish, ready-to-cook foods, honey, coconut, spices, mushrooms, perishable food retail stores, etc. This scheme allows farmers to link with processors and the Market to guarantee profitable prices for agricultural products. The scheme is implemented by agencies / organizations such as the government, UPMs, joint ventures, NGOs, cooperatives, SHGs, MROs, the private sector, individuals, etc.</p>

//                               </div>
//                         </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>                      
//                       <Row className="g-4 align-items-start">
//                           <Col lg={12} xl={12}>
//                               <div>

//                                   <p>The Ministry has hired Technical Agencies (TA) to assist farmers / producer groups, including agricultural producer companies, agricultural producer organizations and support groups, to facilitate their participation in the program. The TAs are responsible for preparing the business plan, detailed project report, capacity building, apprenticeship training and other related support services. For Responsibilities of TAs and for contact Enrich Services.</p>
//                                   <p>Proposals to Seek Assistance under the scheme are invited to seek assistance at the time. To view noticing for proposals (contact us) and to submit proposals online.</p>
//                                   <p>The scheme has been in implementation since 2018. To view the implementation status of the backward and Forward Creation (CBFL) projects,</p>
                              
//                               <h2>Pattern of Assistance:</h2>
//                               <p>The maximum grant awarded per project is Rs 5.00 crore @ 35% of the eligible project costs for general areas and @ 50% for the Northeastern states, Himalayan states, ITDP areas or islands. The grant is only granted for technical construction work and eligible machines and systems.</p>

//                                   <h2>Release of Grant</h2>
//                                   <p>The grant under the scheme will be released in three installments of 25%, 40% and 35% as indicated below</p>
//                                   <p>The first installment of 25% of the approved grant will be released after ensuring that 25% of the promoter's contribution and 25% of the temporary loan are used towards the cost of the eligible project.</p>
//                                   <p>The second installment of 40% of the grant will be released after the use of the first installment of the released grant, 65% of the promoter's contribution and 65% of the fixed-term loan has been ensured.</p>
//                                   <p>The third and final installment of the remaining 35% of the scheme approved grant will be released after the use of the second installment, 100% of the promoter's contribution and 100% of the fixedterm loan has been guaranteed.</p>
                              
//                                   <h2>Project components</h2>
//                                   <p>1. Backward Linkage:</p>
//                                   <ul>
//                                     <li>Integrated Pack-house(s) (with mechanized sorting & grading line/ packing line/ waxing line/ staging cold rooms/cold storage, etc.)</li>
//                                     <li>Milk Chilling Centre(s) /Bulk Milk Cooler(s)</li>
//                                     <li>Pre-Cooling Unit(s)/ Chillers</li>
//                                     <li>Reefer boats</li>
//                                     <li>Machinery & equipment for minimal processing and/or value addition such as cutting, dicing, slicing, pickling, drying, pulping, canning, waxing, etc.</li>
//                                     <li>Machinery & equipment for packing/ packaging.</li>
//                                   </ul>

//                                   <p>2. Forward Linkage:</p>
//                                   <ul>
//                                     <li>Retail chain of outlets including facilities such as frozen storage/ deep freezers/ refrigerated display cabinets/cold room/ chillers/ packing/ packaging, etc.</li>
//                                     <li>Distribution center associated with the retail chain of outlets with facilities like cold room/ cold storage/ ripening chamber.Transport:</li>
//                                   </ul>

//                                   <p>Refrigerated/ Insulated transport / Reefer Vans in conjunction with backward and forward linkages.</p>

//                                   <h2>How we Assist you?</h2>
//                                   <p>Now that we have looked at how linkages work and how they are vital for the success, we can start going in-depth on how to achieve the goals in both forward and backward linkage processes as an IA and as a TA as well. For additional information on Creation of Backward and Forward Linkages and its elements, you can browse our knowledge base and follow us on Facebook .</p>
//                               </div>
//                               </Col>
//                           </Row>
//             </Container>
//         </section>
        
//     </div>
//     </>    
//   );
// }

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaGlobe,
  FaList,
  FaIndustry,
  FaRocket,
  FaHandsHelping
} from "react-icons/fa";

export default function CBFL() {
  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4">
            <Col lg={12}>
              <h1>
                Creation of Backward & Forward Linkages (CBFL)
              </h1>

              <p>
                The CBFL Scheme by MoFPI is designed to strengthen supply chains
                by connecting farmers, processors, and markets through integrated infrastructure.
              </p>

              <p>
                It ensures raw material availability, reduces wastage, and improves
                market access for agricultural products.
              </p>
            </Col>
          </Row>

          {/* OBJECTIVE */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Objective of the Scheme
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Strengthen farm-to-market linkages</li>
            <li><FaCheckCircle /> Ensure raw material availability</li>
            <li><FaCheckCircle /> Improve farmer income</li>
            <li><FaCheckCircle /> Reduce post-harvest losses</li>
            <li><FaCheckCircle /> Promote value chain integration</li>
          </ul>

          {/* ABOUT */}
          <h2 className="section-title">
            <FaList className="icon" /> About the Scheme
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Supports fruits, vegetables, dairy, meat & more</li>
            <li><FaCheckCircle /> Enables direct farmer-to-market connection</li>
            <li><FaCheckCircle /> Reduces intermediaries</li>
            <li><FaCheckCircle /> Improves price realization</li>
          </ul>

          {/* ELIGIBILITY */}
          <h2 className="section-title">
            <FaList className="icon" /> Who Can Apply
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Government agencies</li>
            <li><FaCheckCircle /> FPOs & cooperatives</li>
            <li><FaCheckCircle /> NGOs & SHGs</li>
            <li><FaCheckCircle /> Private companies & individuals</li>
            <li><FaCheckCircle /> Joint ventures</li>
          </ul>

          {/* FINANCIAL */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Financial Assistance
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> 35% subsidy (general areas)</li>
            <li><FaCheckCircle /> 50% subsidy (NE & special areas)</li>
            <li><FaCheckCircle /> Maximum ₹5 Crores</li>
            <li><FaCheckCircle /> Covers plant & machinery + civil work</li>
          </ul>

          {/* GRANT */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Grant Release Structure
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> 25% – Initial stage</li>
            <li><FaCheckCircle /> 40% – Mid-stage progress</li>
            <li><FaCheckCircle /> 35% – After completion</li>
          </ul>

          {/* COMPONENTS */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Project Components
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Pack houses & cold storage</li>
            <li><FaCheckCircle /> Milk chilling centers</li>
            <li><FaCheckCircle /> Pre-cooling & processing units</li>
            <li><FaCheckCircle /> Retail outlets & distribution centers</li>
            <li><FaCheckCircle /> Refrigerated transport & logistics</li>
          </ul>

          {/* TECH AGENCY */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Role of Technical Agencies
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> DPR & business planning</li>
            <li><FaCheckCircle /> Project structuring</li>
            <li><FaCheckCircle /> Training & capacity building</li>
            <li><FaCheckCircle /> Implementation support</li>
          </ul>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            At Apex Consultants, we provide complete support including DPR preparation,
            application filing, financial structuring, and coordination with authorities
            to ensure smooth approvals and subsidy benefits.
          </p>

          {/* WHY */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Why Choose Us
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> End-to-end project execution</li>
            <li><FaCheckCircle /> Expert documentation</li>
            <li><FaCheckCircle /> Faster approvals</li>
            <li><FaCheckCircle /> Subsidy optimization</li>
            <li><FaCheckCircle /> Ongoing support</li>
          </ul>

        </Container>
      </section>
    </div>
  );
}